// Create a Map to store player instances
let playerInstances = new Map()

let lastTimeWeCalled = false

// Wrap a single iframe in a Vimeo.Player and register it. Idempotent: an iframe
// already in the Map is returned as-is, so this is safe to call per-iframe (e.g.
// after a lazy iframe gets its src) without the content_ready throttle below.
var wrapPlayerForIframe = function (iframe) {
	if (typeof Vimeo == 'undefined') {
		return null
	}
	var existing = playerInstances.get(iframe)
	if (existing) {
		return existing
	}

	const player = new Vimeo.Player(iframe)
	player.ready().then(function () {
		// The player is ready
		iframe.dataset.ready = 'true'
		iframe.closest('.video').classList.add('lay-vimeo-ready')
		// if we are in view and autoplay is set to true, play the video
		let rect = iframe.getBoundingClientRect()
		let inView = rect.top < window.innerHeight && rect.bottom > 0
		let autoplay = iframe.closest('.lay-vimeo-autoplay')

		if (inView && autoplay) {
			// Only try to play if we're in view and autoplay is enabled
			player.getPaused().then(function (paused) {
				if (paused) {
					player.play().catch((error) => {
						if (error.name !== 'PlayInterrupted') {
							console.error('Error playing video:', error)
						}
					})
				}
			})
		} else if (!inView && autoplay) {
			// Make sure it's paused if we're not in view
			player.getPaused().then(function (paused) {
				if (!paused) {
					player.pause()
				}
			})
		}
	})
	// Store the player instance in our Map
	playerInstances.set(iframe, player)
	return player
}

var initVimeoSDKPlayers = function ($iframes) {
	if (typeof Vimeo == 'undefined') {
		return
	}
	if (lastTimeWeCalled && Date.now() - lastTimeWeCalled < 1000) {
		return
	}
	lastTimeWeCalled = Date.now()

	$iframes.each(function () {
		wrapPlayerForIframe(this)
	})
}

// Destroy every player whose iframe has left the DOM (an AJAX navigation
// swapped the page content). Without this the Map only ever grows: each
// navigation leaves the old Vimeo.Player objects — and the heavy player
// runtime + full-size poster they hold — alive forever. On iOS that
// accumulation exhausts memory and crashes the renderer.
//
// An iframe that's merely hidden under an open project overlay is still in the
// document, so its player survives and resumes when the overlay closes.
var destroyDetachedPlayers = function () {
	playerInstances.forEach(function (player, iframe) {
		if (document.contains(iframe)) {
			return
		}
		try {
			var result = player && typeof player.destroy === 'function' ? player.destroy() : null
			if (result && typeof result.catch === 'function') {
				result.catch(function () {})
			}
		} catch (e) {}
		playerInstances.delete(iframe)
	})
}

if (window.laytheme && typeof window.laytheme.on === 'function') {
	window.laytheme.on('newpageshown', destroyDetachedPlayers)
}

// Export the playerInstances Map so it can be accessed by other modules
export { playerInstances, destroyDetachedPlayers, wrapPlayerForIframe }
export default initVimeoSDKPlayers
